// 2. TimelineCollaborators Component
// src/components/Timeline/components/TimelineCollaborators.tsx
import React from 'react';
import {
   Dialog,
   DialogTitle,
   DialogContent,
   Box,
   Typography,
   IconButton,
   Avatar,
   Chip,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { TripCollaborator } from '../types';

interface TimelineCollaboratorsProps {
   open: boolean;
   collaborators: TripCollaborator[];
   onClose: () => void;
}

const TimelineCollaborators: React.FC<TimelineCollaboratorsProps> = ({
   open,
   collaborators,
   onClose,
}) => {
   return (
      <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
         <DialogTitle>
            People with Access
            <IconButton
               aria-label='close'
               onClick={onClose}
               sx={{ position: 'absolute', right: 8, top: 8 }}
               size='small'
            >
               <CloseIcon />
            </IconButton>
         </DialogTitle>
         <DialogContent>
            {collaborators.length === 0 ? (
               <Typography color='text.secondary'>
                  This trip is not shared with anyone else.
               </Typography>
            ) : (
               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {collaborators.map((collaborator: any) => (
                     <Box
                        key={collaborator?.id}
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           p: 1,
                           borderRadius: 1,
                           '&:hover': { bgcolor: 'action.hover' },
                        }}
                     >
                        <Avatar src={collaborator?.avatar} sx={{ mr: 2 }}>
                           {collaborator?.name?.charAt(0)}
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                           <Typography variant='body1'>{collaborator?.name}</Typography>
                           <Typography variant='body2' color='text.secondary'>
                              {collaborator?.status === 'owner'
                                 ? 'Owner'
                                 : collaborator?.status === 'editor'
                                 ? 'Can edit'
                                 : 'Can view'}
                           </Typography>
                        </Box>
                        {collaborator?.status === 'owner' && (
                           <Chip label='Owner' size='small' color='primary' variant='outlined' />
                        )}
                     </Box>
                  ))}
               </Box>
            )}
         </DialogContent>
      </Dialog>
   );
};

export default TimelineCollaborators;
